// @ts-ignore
import { IAction } from 'types/action';
import { IRedemptionState } from 'widgets/redeem/modules/redemption/v2/redemption.reducer';
import { SWITCH_PREVIEW_STATE_HOST } from '@sitegen/common/types/root-actions';
import { REDEEM_SUCCESS_V1, REDEEM_SUCCESS_V2 } from '../../states/states.constants';
import { Benefit, PLATFORM_CODE } from '@sitegen/common/types/redemption.types';
import { BENEFIT_ID_MOCK } from '@sitegen/common/constants/entitlements';

export const initialState: IRedemptionState = {
    fetching: null,
    benefits: null,
    error: null,
    platforms: null
};

const benefits: Benefit[] = [
    {
        benefitId: BENEFIT_ID_MOCK,
        name: 'ps4_item',
        platformType: PLATFORM_CODE.PS4
    },
    {
        benefitId: BENEFIT_ID_MOCK,
        name: 'pc_item',
        platformType: PLATFORM_CODE.UPLAY
    }
];
// @ts-ignore
export const redemptionReducer = (state: IRedemptionState = initialState, action: IAction): IRedemptionState => {
    switch (action.type) {
    case SWITCH_PREVIEW_STATE_HOST: {
        switch (action.payload) {
        case REDEEM_SUCCESS_V2: {
            return { ...state, benefits };
        }
        case REDEEM_SUCCESS_V1: {
            return { ...state, benefits: null };
        }
        default: return state;
        }
    }
    default: return state;
    }
};

export default redemptionReducer;
